import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AGENT_SESSIONS } from '../../../constants/queryKeys';
import { ChatMessage } from '../types';

export type HistoryData = {
  threadId: string;
  messages: ChatMessage[];
};

type UseChatHistoryProps = {
  open: boolean;
};

export const useChatHistory = ({ open }: UseChatHistoryProps) => {
  const [history, setHistory] = useState<HistoryData>();

  const queryClient = useQueryClient();

  const invalidateHistory = () =>
    queryClient.invalidateQueries([AGENT_SESSIONS]);

  const resetChatHistory = () => {
    setHistory(undefined);
    invalidateHistory();
  };

  const handleSelectHistory = (history: HistoryData) => {
    setHistory(history);
  };

  // resetting history on close, invalidating on open
  useEffect(() => {
    if (!open) {
      setHistory(undefined);
    }
    if (open) {
      invalidateHistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return {
    history,
    resetChatHistory,
    handleSelectHistory,
  };
};
